import React, { useState } from 'react';
import { UploadIcon, PaletteIcon, GlobeIcon } from 'lucide-react';
export function BrandingConfigurator() {
  const [brandColor, setBrandColor] = useState('#dc2626');
  const [logoUrl, setLogoUrl] = useState('');
  return <div className="max-w-5xl mx-auto" data-id="element-676">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-677">
        {/* Configuration Panel */}
        <div className="space-y-6" data-id="element-678">
          {/* Logo Upload */}
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-679">
            <div className="flex items-center gap-2 mb-4" data-id="element-680">
              <UploadIcon className="w-5 h-5 text-red-600" data-id="element-681" />
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-682">Logo</h3>
            </div>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-red-500 transition-colors cursor-pointer" data-id="element-683">
              <UploadIcon className="w-8 h-8 text-gray-400 mx-auto mb-2" data-id="element-684" />
              <p className="text-sm text-gray-600 mb-1" data-id="element-685">Click to upload logo</p>
              <p className="text-xs text-gray-500" data-id="element-686">PNG or SVG, max 2MB</p>
            </div>
          </div>
          {/* Brand Colors */}
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-687">
            <div className="flex items-center gap-2 mb-4" data-id="element-688">
              <PaletteIcon className="w-5 h-5 text-red-600" data-id="element-689" />
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-690">
                Brand Colors
              </h3>
            </div>
            <div className="space-y-4" data-id="element-691">
              <div data-id="element-692">
                <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-693">
                  Primary Color
                </label>
                <div className="flex items-center gap-3" data-id="element-694">
                  <input type="color" value={brandColor} onChange={e => setBrandColor(e.target.value)} className="w-12 h-12 rounded border border-gray-300 cursor-pointer" data-id="element-695" />
                  <input type="text" value={brandColor} onChange={e => setBrandColor(e.target.value)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent font-mono" data-id="element-696" />
                </div>
              </div>
            </div>
          </div>
          {/* Custom Domain */}
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-697">
            <div className="flex items-center gap-2 mb-4" data-id="element-698">
              <GlobeIcon className="w-5 h-5 text-red-600" data-id="element-699" />
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-700">
                Custom Domain
              </h3>
            </div>
            <div className="space-y-4" data-id="element-701">
              <div data-id="element-702">
                <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-703">
                  Domain Name
                </label>
                <input type="text" placeholder="gtm.yourcompany.com" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-704" />
                <p className="text-xs text-gray-600 mt-2" data-id="element-705">
                  You will need to add a CNAME record to your DNS
                </p>
              </div>
              <button className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium" data-id="element-706">
                Verify Domain
              </button>
            </div>
          </div>
        </div>
        {/* Preview Panel */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-707">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-708">
            Live Preview
          </h3>
          <div className="border-2 border-gray-200 rounded-lg overflow-hidden" data-id="element-709">
            {/* Preview Header */}
            <div className="px-6 py-4 flex items-center gap-3" style={{
            backgroundColor: brandColor
          }} data-id="element-710">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-sm font-bold" data-id="element-711">
                {logoUrl ? <img src={logoUrl} alt="Logo" className="w-full h-full object-contain" data-id="element-712" /> : <span style={{
                color: brandColor
              }} data-id="element-713">
                    LOGO
                  </span>}
              </div>
              <div data-id="element-714">
                <h4 className="text-white font-bold" data-id="element-715">Your Company</h4>
                <p className="text-white text-xs opacity-90" data-id="element-716">GTM Portal</p>
              </div>
            </div>
            {/* Preview Content */}
            <div className="p-6 space-y-4" data-id="element-717">
              <div className="flex items-center gap-2" data-id="element-718">
                <div className="w-3 h-3 rounded-full" style={{
                backgroundColor: brandColor
              }} data-id="element-719" />
                <p className="text-sm text-gray-600" data-id="element-720">Primary color in action</p>
              </div>
              <button className="px-4 py-2 text-white rounded-lg font-medium" style={{
              backgroundColor: brandColor
            }} data-id="element-721">
                Primary Button
              </button>
              <div className="p-4 border rounded-lg" style={{
              borderColor: brandColor
            }} data-id="element-722">
                <p className="text-sm text-gray-600" data-id="element-723">Branded border elements</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}